import { vuexHandbook } from '@/store/composition/handbook'
import { HookOrientationApi } from '@/api/handbook/position/HookOrientation/HookOrientationApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: HookOrientationApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
